import {Routes} from '@angular/router';
import {genericResourceRoutes} from '@catcore/shared/routes';
import {FeatureDetailsComponent} from '@catfeatures/components/feature-details/feature-details.component';
import {FeaturePropertiesComponent} from '@catfeatures/components/feature-properties/feature-properties.component';
import {FeatureFixedRoutesLandingComponent} from '@catfeatures/components/landing-pages/feature-fixed-routes-landing/feature-fixed-routes-landing.component';
import {FeatureOptionTokensWelcomeComponent} from '@catfeatures/components/landing-pages/feature-option-tokens-welcome/feature-option-tokens-welcome.component';
import {FeaturePortsLandingComponent} from '@catfeatures/components/landing-pages/feature-ports-landing/feature-ports-landing.component';
import {FeatureServicesWelcomeComponent} from '@catfeatures/components/landing-pages/feature-services-welcome/feature-services-welcome.component';
import {FeatureUnitsWelcomeComponent} from '@catfeatures/components/landing-pages/feature-units-welcome/feature-units-welcome.component';
import {FeatureGroupTypeResolve} from '@catfeatures/services/feature-group-type.resolve';
import {FeatureResolve} from '@catfeatures/services/feature.resolve';
import {FeaturesResolve} from '@catfeatures/services/features.resolve';
import {StatusesResolve} from '@catfeatures/services/statuses.resolve';
import {FeatureEvidFunctionsWelcomeComponent} from '@catmodules/models/feature-evid-functions/components/feature-evid-functions-welcome/feature-evid-functions-welcome.component';

import {FeatureListComponent} from './components/feature-list/feature-list.component';
import {FeatureWelcomeComponent} from './components/feature-welcome/feature-welcome.component';
import {FeatureGgwDeviceLandingComponent} from "@catmodels/ggw-device/components/feature-ggw-device-landing/feature-ggw-device-landing.component";
import {FeatureAvodCatalogCreateComponent} from "@catmodels/avod-catalog/components/feature-avod-catalog-create/feature-avod-catalog-create.component";
import {FeatureProjectUsagesComponent} from "@catfeatures/components/project-usages/feature-project-usages.component";
import {FeatureDynamicRoutesLandingComponent} from "@catfeatures/components/landing-pages/feature-dynamic-routes-landing/feature-dynamic-routes-landing.component";

/**
 * List of all the routes and there targets a single Feature or a list of Features
 *
 * @type {{path: string; component: FeatureListComponent; resolve: {featureTypes: FeaturesResolve}; children: ({path: string; component: FeatureWelcomeComponent; resolve: {statuses: StatusesResolve; featureTypeGroups: FeatureGroupTypeResolve}} | {path: string; component: FeatureDetailsComponent; resolve: {feature: FeatureResolve}; children: ({path: string; component: FeaturePropertiesComponent} | {path: string; component: FeatureUnitsWelcomeComponent} | {path: string; component: FeatureServicesWelcomeComponent} | {path: string; component: FeatureEvidFunctionsWelcomeComponent} | {path: string; component: FeatureGgwImplementationsWelcomeComponent} | {path: string; component: FeatureGgwDevicesLandingComponent} | {path: string; component: FeaturePortsLandingComponent} | {path: string; component: ResourceMapComponent} | {path: string; component: ResourceWizardComponent} | {path: string; component: ResourceComponent})[]})[]}[]}
 */
export const routes: Routes = [
  {
    path: '',
    component: FeatureListComponent,
    resolve: {
      featureTypes: FeaturesResolve,
    },
    children: [
      {
        path: '',
        component: FeatureWelcomeComponent,
        resolve: {
          statuses: StatusesResolve,
          featureTypeGroups: FeatureGroupTypeResolve,
        },
      },
      {
        path: ':id',
        component: FeatureDetailsComponent,
        resolve: {
          feature: FeatureResolve,
        },
        children: [
          {
            path: 'properties',
            component: FeaturePropertiesComponent,
          },
          {
            path: 'units',
            component: FeatureUnitsWelcomeComponent,
          },
          {
            path: 'services',
            component: FeatureServicesWelcomeComponent,
          },
          {
            path: 'evid-functions',
            component: FeatureEvidFunctionsWelcomeComponent,
          },
          {
            path: 'ggw-devices',
            component: FeatureGgwDeviceLandingComponent,
          },
          {
            path: 'fixed-routes',
            component: FeatureFixedRoutesLandingComponent,
          },
          {
            path: 'dyn-route-templates',
            component: FeatureDynamicRoutesLandingComponent,
          },
          {
            path: 'ports',
            component: FeaturePortsLandingComponent,
          },
          {
            path: 'option-tokens',
            component: FeatureOptionTokensWelcomeComponent,
          },
          {
            path: 'avod-catalog-create',
            component: FeatureAvodCatalogCreateComponent,
          },
          {
            path: 'project-usages',
            component: FeatureProjectUsagesComponent,
          },
          ...genericResourceRoutes,
        ],
      },

    ],
  },
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/features.routing.ts